import get from 'lodash/get';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
// MIDDLEWARES
import CommonMiddleware from '../middlewares/CommonMiddleware';
import CompanyMiddleware from '../middlewares/CompanyMiddleware';
import ImageMiddleware from '../middlewares/UploadMiddleware';
import UserMiddleware from '../middlewares/UserMiddleware';
import rootReducer from '../reducers';
const middlewares = [thunk];
const getIfDev = (get(window, 'location.href', '')).split('?');
// @ts-ignore
if (typeof window !== 'undefined' && (process.env.NODE_ENV === 'development' || (getIfDev[1] && getIfDev[1].includes('dev=true')))) {
    middlewares.push(createLogger({
        collapsed: true,
        colors: {
            title: () => '#002bff',
            prevState: () => '#de6f0d',
            action: () => '#6e13ab',
            nextState: () => '#1a9134',
        },
    }));
}
const composeEnhancers = composeWithDevTools({});
const composedEnhancers = composeEnhancers(applyMiddleware(...middlewares, CommonMiddleware, CompanyMiddleware, ImageMiddleware, UserMiddleware));
export const configureStore = createStore(rootReducer, {}, composedEnhancers);
const store = createStore(rootReducer);
export default store;
